module.exports = __webpack_public_path__ + "img/55.a6f4e5b0.svg";